import type { FaireProductEntity } from "../../entity_types/product";

export const p_dmcvgxxpku: FaireProductEntity = {
  token: "p_dmcvgxxpku",
  type: "product",
  name: "pink balloons mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/50c53f87a2594bf9779f47f6db984a81e62e67c263b0949b6409452d359f18a6.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope \n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n\n\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:09.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
